import { AlertsBaseDataProvider } from './AlertsBaseDataProvider';
import { sanitizeObject } from '../../utils/sanitization.utils';
import {
  CreateViewRequest,
  CreateViewResponse,
  DeleteViewRequest,
  DeleteViewResponse,
  InitAlertsRequest,
  UpdateActiveViewRequest,
  UpdateActiveViewResponse,
  UpdateSmartViewsStateRequest,
  UpdateSmartViewsStateResponse,
  UpdateViewPropsRequest,
  UpdateViewPropsResponse,
  ValidateViewNameRequest,
  ValidateViewNameResponse,
} from '@nirvana/shared/dtos/types/alerts/gz-console';
import { getRequestDefaultOptions } from '../../utils/request.utils';
import {
  GetAllColumnDetailsRequest,
  GetAllColumnDetailsResponse,
  InitAlertsResponse,
} from '@nirvana/shared/dtos/types/alerts/common';

export class AlertsNirvanaDataProvider extends AlertsBaseDataProvider {
  async initAlerts(request: InitAlertsRequest): Promise<InitAlertsResponse> {
    const response = await this.dependencies.api.clients.Alerts.initAlerts(
      request,
      getRequestDefaultOptions()
    ).toPromise();
    return response;
  }

  async getAllColumnDetails(request: GetAllColumnDetailsRequest): Promise<GetAllColumnDetailsResponse> {
    const response = await globalThis.clients.Alerts.getAllColumnDetails(
      request,
      getRequestDefaultOptions()
    ).toPromise();

    return sanitizeObject(response);
  }

  public async deleteView(request: DeleteViewRequest): Promise<DeleteViewResponse> {
    const response = await this.dependencies.api.clients.Alerts.deleteView(
      request,
      getRequestDefaultOptions()
    ).toPromise();

    return sanitizeObject(response);
  }

  public async createView(request: CreateViewRequest): Promise<CreateViewResponse> {
    const response = await this.dependencies.api.clients.Alerts.createView(
      request,
      getRequestDefaultOptions()
    ).toPromise();

    return response;
  }

  public async updateActiveView(request: UpdateActiveViewRequest): Promise<UpdateActiveViewResponse> {
    const response = await this.dependencies.api.clients.Alerts.updateActiveView(
      request,
      getRequestDefaultOptions()
    ).toPromise();
    return response;
  }

  public async updateViewProps(request: UpdateViewPropsRequest): Promise<UpdateViewPropsResponse> {
    const response = await this.dependencies.api.clients.Alerts.updateViewProps(
      request,
      getRequestDefaultOptions()
    ).toPromise();
    return response;
  }

  public async validateViewName(request: ValidateViewNameRequest): Promise<ValidateViewNameResponse> {
    const response = await this.dependencies.api.clients.Alerts.validateViewName(
      request,
      getRequestDefaultOptions()
    ).toPromise();
    return sanitizeObject(response);
  }

  public async updateSmartViewsState(request: UpdateSmartViewsStateRequest): Promise<UpdateSmartViewsStateResponse> {
    const response = await this.dependencies.api.clients.Alerts.updateSmartViewsState(
      request,
      getRequestDefaultOptions()
    ).toPromise();
    return sanitizeObject(response);
  }
}
